var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.afterDays
    ? _c(
        "v-tooltip",
        {
          class: { "ml-1": !_vm.noSpacing },
          attrs: { bottom: "" },
          scopedSlots: _vm._u(
            [
              {
                key: "activator",
                fn: function(ref) {
                  var on = ref.on
                  return [
                    _c(
                      "v-chip",
                      _vm._g(
                        {
                          attrs: {
                            color: "red",
                            "x-small": "",
                            "text-color": "white"
                          }
                        },
                        on
                      ),
                      [_vm._v(" " + _vm._s(_vm.date) + " ")]
                    )
                  ]
                }
              }
            ],
            null,
            false,
            1642437254
          )
        },
        [
          _c("span", [
            _vm._v(
              " Ativo está a " +
                _vm._s(Math.abs(_vm.daysAfter)) +
                " dias sem atualizar o P/L. Verifique seus dados ou Importe-o novamente"
            )
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }